var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultDevice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 8,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 8,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.01053 11C4.45243 11 4 11.4524 4 12.0105V17.4619C4 18.02 4.45243 18.4724 5.01053 18.4724H51.9895C52.5476 18.4724 53 18.02 53 17.4619V12.0105C53 11.4524 52.5476 11 51.9895 11H5.01053ZM38.5 15C38.2239 15 38 15.2239 38 15.5C38 15.7761 38.2239 16 38.5 16H45.5C45.7761 16 46 15.7761 46 15.5C46 15.2239 45.7761 15 45.5 15H38.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 20.5C9 20.2745 9.18399 20.0935 9.40944 20.0935H48.5906C48.816 20.0935 49 20.2745 49 20.5C49 33.4787 40.0457 44 29 44C17.9543 44 9 33.4787 9 20.5ZM29 38C32.3137 38 35 35.3137 35 32C35 28.6863 32.3137 26 29 26C25.6863 26 23 28.6863 23 32C23 35.3137 25.6863 38 29 38Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultDevice);
export default __webpack_public_path__ + "static/media/default-device.f3e866378ae329ee47c66f739f4aeefa.svg";
export { ForwardRef as ReactComponent };